Ext.define('SA.data.AttributesHierarchyPlaceholdersQuery', {
    alias: 'query.attributes-hierarchy-placeholders',
    extend: 'SA.data.Query',

    fieldsProperty: 'fields',
    resource: 'attributes/hierarchyPlaceholders',
    whereProperty: 'where',

    createParams() {
        var params = this.callParent();

        params.data.edition = this.edition;

        return params;
    },

    mapResult({result, placeholder}) {
        if (result) {
            result = this.callParent([result]);
        }

        return {result, placeholder};
    }
});